<template>
  <BaseDialog
    :title="isShowMode ? 'Просмотр' : isEdit ? 'Редактировать' : 'Добавить'"
    :dialog="dialog"
    :is-show-mode="isShowMode"
    :is-edit="isEdit"
    :is-invalid="$v.$invalid"
    :save-btn-loading="saveBtnLoading"
    @close="closeModal"
    @save="save"
  >
    <TabsUI
      v-if="!isXs"
      :list="tabsArr"
      :selected-tab="tabsArr.findIndex(obj => selectedTab && obj.id === selectedTab.id)"
      compact
      center
      @click="(tab) => selectedTab = tab"
    />

    <div v-if="isXs" class="d-flex row justify-center mb-2">
      <v-btn
        v-for="(btn, i) in tabsArr"
        :key="i"
        small
        :full="selectedTab.id === btn.id"
        :outlined="selectedTab.id !== btn.id"
        :color="selectedTab.id === btn.id ? 'primary' : 'lightGrey'"
        class="mb-2 w-full"
        @click="selectedTab = btn"
      >
        {{ btn.name }}
      </v-btn>
    </div>

    <UITextField
      v-if="selectedTab.id === tabs.new.id"
      v-model="formTemplate.name"
      label="Название"
      class="mt-2"
      :disabled="isShowMode"
      :error-messages="errorMessages.name"
      @input="$v.formTemplate.name.$touch()"
    />

    <UIAutocomplete
      v-if="selectedTab.id === tabs.copy.id"
      v-model="selectedFormTemplatePrototype"
      label="Создать на основании"
      class="mt-2"
      return-object
      :no-filter="false"
      :items="allFormTemplateList"
      item-value="id"
      :item-text="getFormTemplateName"
      :disabled="isShowMode"
      :error-messages="errorMessages.selectedFormTemplatePrototype"
      @input="$v.formTemplate.name.$touch()"
    />
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/ui/dialog/BaseDialog'
import UITextField from '@/ui/input/UITextField'
import { FormTemplate } from '@/models'
import { setValidateMessages } from '@/scripts/validation'
import {
  maxLength,
  requiredIf,
} from 'vuelidate/lib/validators'
import UIAutocomplete from '@/ui/input/UIAutocomplete'
import TabsUI from '@/featureSlicedDesign/shared/ui/TabsUI'
import { mapGetters } from 'vuex'

export default {
  components: {
    TabsUI,
    UIAutocomplete,
    UITextField,
    BaseDialog,
  },

  props: {
    isShowMode: Boolean,
    saveBtnLoading: Boolean,
    dialog: Boolean,
    selectedItem: {
      type: Object,
      default: null,
    },
    allFormTemplateList: {
      type: Array,
      default: () => [],
    },
  },

  created() {
    this.tabsArr = Object.values(this.tabs)
    this.selectedTab = this.tabsArr[0]
  },

  data: () => ({
    formTemplate: new FormTemplate(),
    selectedFormTemplatePrototype: null,

    selectedTab: null,
    tabsArr: [],
    tabs: {
      new: { id: 1, name: 'Создать новую' },
      copy: { id: 2, name: 'Копировать существующую' }
    },
  }),

  validations() {
    return {
      formTemplate: {
        name: {
          required: requiredIf(() => this.selectedTab.id === this.tabs.new.id),
          maxLength: maxLength(200)
        }
      },
      selectedFormTemplatePrototype: {
        required: requiredIf(() => this.selectedTab.id === this.tabs.copy.id)
      }
    }
  },

  computed: {
    ...mapGetters('breakpoint', ['isXs']),

    isEdit() {
      return !!this.selectedItem?.id
    },

    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.formTemplate.$params).forEach((key) => {
        allErrors[key] = setValidateMessages(this.$v.formTemplate[key])
      })

      return allErrors
    },
  },

  methods: {
    getFormTemplateName(formTemplate) {
      return `${formTemplate.name} (${formTemplate.event.name})`
    },

    save() {
      if (this.selectedTab.id === this.tabs.new.id) {
        this.$emit('saveFormTemplate', this.formTemplate.getForAPI())
      }

      if (this.selectedTab.id === this.tabs.copy.id) {
        this.$emit('copyFormTemplate', this.selectedFormTemplatePrototype)
      }
    },

    resetModal() {
      this.$v.$reset()
      this.selectedFormTemplatePrototype = null
    },

    closeModal() {
      this.$emit('closeModal')
    },
  },

  watch: {
    selectedItem(val) {
      this.formTemplate = new FormTemplate(val)
    },

    dialog(val) {
      !val && this.resetModal()
    },
  },
}
</script>
